module.exports = __webpack_public_path__ + "static/media/call_button.21c85596.svg";